import React from 'react';
import LanguageSelectFlag from '../flag';
const Option = ({ value, label, iconComponent }) => (
  <div className="ws-ui-language-select-option" key={value}>
    <LanguageSelectFlag>{iconComponent}</LanguageSelectFlag>
    <div className="ws-ui-language-select-option__name">{label}</div>
  </div>
);

export default Option;
